import makeStyles from '@material-ui/core/styles/makeStyles'
import { Text } from '../../../components/1elements'

const MenuGroup = ({ children, text }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Text type="h4" className={classes.menuGroupTitle}>
        {text}
      </Text>
      <div className={classes.menuGroupContent}>{children}</div>
    </div>
  )
}

export default MenuGroup

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: '40px'
  },
  menuGroupTitle: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '13px 5px 13px 25px',
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    borderBottom: `1px solid ${theme.palette.secondary.main}`
  },
  menuGroupContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 15px'
  }
}))
